'use client';

import type { UseMutationOptions } from '@tanstack/react-query';
import type { ClientError } from 'graphql-request';
import type { UpdateProductMutation, UpdateProductMutationVariables} from 'generated/graphql';
import { useUpdateProductMutation } from 'generated/graphql';
import { graphqlClient } from 'lib/api';

export default function useUpdateProduct(
  options?: UseMutationOptions<UpdateProductMutation, ClientError, UpdateProductMutationVariables>,
  headers?: RequestInit['headers'],
) {
  return useUpdateProductMutation(graphqlClient, options, headers);
}
